import { SitioOportunity } from '../../../utils/global';
import { roundToTwo, formatCurrency } from '../../../utils/helpMain'

const GetCurrecyPV = (plan: string) => ((plan.trim() === '595') ? 'U$' : '¢')

const BuildDataPolicy = (data: IIHContenidoSeguroCR) => {
    let polCobs: any = [];
    let polCobsDesc: any = [];
    let oa: any = {}

    const resumen = data.lstRateResumen[parseInt(data.planSelected) - 1]
    const frecuency = data.catQuotas.find(x => x.value === data.nQuotas)?.text2 ?? ''


    let policy: any = {
        Plan: data.plan,
        SA: resumen.sumInsured,
        Prima: resumen.bonus,
        Descuento: resumen.desc,
        PrimaDE: resumen.bonus,
        PrimaNeta: resumen.bonus2,
        PrimaExonerada: 0,
        Impuesto: resumen.tax,
        Total: resumen.total,
        Frecuencia: frecuency,
        Cuotas: data.nQuotas,
        Estado: 1,
        mInteres: resumen.financing,
        DerechoEmision: resumen.rightEmission,
        ModCobro: 3,
        IdSitio: SitioOportunity.CR.ContenidoSeguro,
    }

    oa = {
        SA: resumen.sumInsured,
        inSumaEdificio: 0,
        inSumaContenido: resumen.sumInsured,
        inAnioConstruccion: 0,
        inDireccion: data.addressRisk,
        inPais: 506,
        inDepartamento: data.province,
        inCiudad: data.canton,
        inDistrito: data.district,
        inBarrio: data.neighborhood,
        inActividad: data.cactividadIH,
        incclaries: data.cclaries,
        inZonaRiesgo: data.riskZone,
        OA_Items: [
            {
                TipoBien_Id: 3,
                Tipo: 2,
                Clasificacion: '2',
                Descripcion: resumen.sumInsuredStr,
                SA: resumen.sumInsured,
                pRiesgo: '2'
            }
        ]
    }

    let insured = {
        TipoId: data.identificationType,
        NumId: data.identification,
        Nombre: `${data.firstName1} ${data.firstName2}`,
        Apellido: `${data.lastName1} ${data.lastName2}`,
        TelefonoCelular: data.phoneNumber,
        Email: data.mail,
        Sexo: data.sex,
        EstadoCivil: 0,
        FechaNacimiento: data.birthdate,
        NombreEmp: data.company,
        TelefonoEmp: data.companyPhone,
        Pais: data.nationality,
        Departamento: data.province,
        Municipio: data.canton,
        Distrito: data.district,
        Barriada: data.neighborhood,
        IngresoMensual: data.monthlyIncome
    }

    const rates = data.lstRate[parseInt(data.planSelected) - 1].RateLst;
    rates.map((rate: IRates) => {
        let nameCover = data.catCoverages.find(x => x.idCob === rate.idCob);
        let tempCover: any = {};
        let prima = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
        let primaDE = 0;
        let pRecargo = 0;
        let mRecargo = 0;
        if (nameCover !== undefined) {

            let porcenDescount = 0;
            let desc = 0
            let idDesc = 0;
            if (rate.descuentos.length > 0) {
                porcenDescount = rate.descuentos[0].porcentaje;
                idDesc = rate.descuentos[0].codigoDescuento
            }
            if (rate.pRecargo > 0) {
                pRecargo = rate.pRecargo;
                mRecargo = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100)));
            }
            if (porcenDescount > 0) {
                let primaDesc = parseFloat(rate.prima);
                desc = roundToTwo((prima) * (porcenDescount / 100))
            }
            primaDE = roundToTwo(prima - desc);


            let Etiqueta = '0';

            tempCover['Nombre'] = nameCover.nombre;
            tempCover['orden'] = nameCover.orden;
            tempCover["IdCob"] = rate.idCob;
            tempCover["SA"] = rate.sa;
            tempCover["Prima"] = prima;//roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
            tempCover["ptasa"] = rate.pTasa;
            tempCover["pdescuento"] = porcenDescount;
            tempCover["mdescuento"] = desc;
            tempCover["pRecargo"] = 0;
            tempCover["mRecargo"] = 0;
            tempCover["mprimabruta"] = primaDE;
            tempCover["PrimaDE"] = primaDE;
            tempCover["Etiqueta"] = Etiqueta;
            tempCover["bDescuentoManual"] = 0;
            tempCover["PrimaGravada"] = primaDE
            tempCover["COA"] = rate.coa || 0
            tempCover["Deducible"] = rate.deducible || 0
            polCobs.push(tempCover);


            if (desc > 0) {
                polCobsDesc.push({
                    idCob: rate.idCob,
                    pdescuento: porcenDescount,
                    mdescuento: desc,
                    codDesc: idDesc,
                    fechaingreso: new Date()
                });
            }
        }
    })


    policy.Respuesta = [];
    policy.Beneficiarios = [];
    policy.PolCobs = polCobs;
    policy.PolCobsDesc = [];
    policy.Oa = oa;
    policy.Asegurado = insured;
    policy.FormaPagos = {};

    return policy;

}


const BuildPayment = (data: IIHContenidoSeguroCR) => {
    return {
        policyId: data.polizaid,
        cardHolder: data.cardName,
        cardNumber: data.cardNumber,
        cvv: data.cardCVV,
        expirationDate: data.cardExpirationDate,
        amountApp: data.feePay,
        currencyApp: GetCurrecyPV(data.plan),
        email: data.mail
    }
}

const BuildNotificationPol = (data: IIHContenidoSeguroCR, code: string) => {
    let dataNotification = { sitio: SitioOportunity.CR.ContenidoSeguro, codigo: code, values: {}, adjuntos: [] as Array<IFileDto> }

    const values: Record<string, string> = {
        'correo': data.mail,
        "idpoliza": data.polizaid.toString(),
        "tiporeporte": 'pol',
        "nombrereporte": `Poliza ${data.cnpoliza}`,
        '{{nombres}}': `${data.firstName1} ${data.firstName2} ${data.lastName1} ${data.lastName2}`,
        '{{poliza}}': data.cnpoliza
    }

    dataNotification.values = values;
    return dataNotification;
}

const BuildNotification = (data: IIHContenidoSeguroCR, code: string, interno: boolean = false) => {

    let dataNotification = { sitio: SitioOportunity.CR.ContenidoSeguro, codigo: code, values: {}, adjuntos: [] as Array<IFileDto> }

    let nationality = data.catNationality.find(x => x.value.toString() === data.nationality.toString());
    let profession = data.catProfession.find(x => x.value.toString() === data.profession.toString())

    const values: Record<string, string> = {
        'interno': interno.toString(),
        "correo": data.mail,
        '{{oferta}}': data.polizaid,
        '{{nombres}}': `${data.firstName1} ${data.firstName2} ${data.lastName1} ${data.lastName2}`,
        '{{identificacion}}': data.identification,
        '{{correoasegurado}}': data.mail,
        '{{celular}}': data.phoneNumber,
        '{{nacionalidad}}': nationality?.text ?? '',
        '{{profesion}}': profession?.text ?? '',
        '{{moneda}}': GetCurrecyPV(data.plan),
        '{{oportunidad}}': data.oportunity,
        '{{plan}}': (parseInt(data.planSelected) + 1).toString(),
        '{{fechaTransaccion}}': '',
        '{{horaTransaccion}}': '',
        '{{poliza}}': '',
        '{{numeroTarjeta}}': '',
        '{{codAutorizacion}}': '',
        '{{montoPagado}}': '',
    }
    dataNotification.values = values;
    return dataNotification;
}

const BuildDataOportunity = (data: IIHContenidoSeguroCR, source: string | null | undefined) => {
    const dataOportunity = {
        Sitio: SitioOportunity.CR.ContenidoSeguro,
        NombreCompleto: `${data.firstName1} ${data.firstName2} ${data.lastName1} ${data.lastName2}`,
        Celular: data.phoneNumber,
        TipoIdentificacion: data.identificationType,
        Identificacion: data.identification,
        Edad: data.age,
        OrigenOportunidad: source,
        IdPoliza: 0,
        Correo: data.mail
    }
    return dataOportunity;
}

const BuildDataNotificationOportunitySL = (data: IIHContenidoSeguroCR) => {
    let dataNotification = { sitio: SitioOportunity.CR.ContenidoSeguro, values: {} }
    const values: Record<string, string> = {
        "{{nombres}}": `${data.firstName1} ${data.firstName2} ${data.lastName1} ${data.lastName2}`,
        "{{identificacion}}": data.identification,
        "{{correoasegurado}}": data.mail,
        "{{celular}}": data.phoneNumber,
        "{{oportunidad}}": '',
    }
    dataNotification.values = values;
    return dataNotification;
}


const BuildSaveCard = (data: IIHContenidoSeguroCR) => {
    return {
        tarjeta: data.cardNumber,
        tipoTarjeta: data.cardType,
        correo: data.mail,
        celular: data.phoneNumber,
        asegurado: `${data.firstName1} ${data.firstName2} ${data.lastName1} ${data.lastName2}`,
        vencimiento: data.cardExpirationDate,
        poliza: data.cnpoliza,
        transactionId: data.transactionId,
        titularTarjeta: data.cardName,
        acepta: true,
        bancoEmisor: data.issuingBank
    }
}
const GetFormatMoneyFeePay = (data: IIHContenidoSeguroCR) => {
    const currency = data.planConfig.moneda.trim()
    return formatCurrency(currency, parseFloat(data.feePay))
}


export {
    BuildDataPolicy,
    BuildPayment,
    BuildNotificationPol,
    BuildDataOportunity,
    BuildNotification,
    BuildDataNotificationOportunitySL,
    BuildSaveCard,
    GetFormatMoneyFeePay
}